export const JOIN_AS_PRO_URL = "/generate-leads";
